import React from "react"
import { navigate } from "gatsby"
import PropTypes from "prop-types"
import {
  filtersTaxoItem,
  filtersTaxoItemChildrenContainer,
  taxoChildren,
  taxoChildrenParentContainer,
} from "../styles/listAdresses.module.scss"
import {
  AdressItemTaxo,
  AdressItemTaxoNotClickable,
} from "../listItems/styled-components/adresse-item-styled"
import { AllBtn } from "gatsby-theme-lantana/src/gatsby-theme-blank/templates/list/listItems/styled-components/adresse-item-styled"

export const FiltreTaxo = ({
  setChoosenTaxo,
  setChoosenTaxoObject,
  setChildrenFinalTaxo,
  choosenTaxo,
  choosenTaxoObject,
  childrenFinalTaxo,
  finalTaxo,
  relatedTaxos,
  toggleTaxo,
  style,
  mobile,
  lantana,
  isVisible,
}) => {
  if (!isVisible) {
    return null
  }
  return (
    <>
      {choosenTaxoObject && choosenTaxoObject.children ? (
        <div className={taxoChildren}>
          <div className={taxoChildrenParentContainer}>
            <AdressItemTaxoNotClickable
              onClick={() => {
                setChoosenTaxo(null)
                setChoosenTaxoObject()
                setChildrenFinalTaxo()
                navigate("/adresses")
              }}
              active={true}
              className={filtersTaxoItem}
            >
              {choosenTaxo}
            </AdressItemTaxoNotClickable>
            {mobile === true && lantana === true ? (
              <AllBtn
                style={style}
                className="btn"
                onClick={() => {
                  setChoosenTaxo(null)
                  setChoosenTaxoObject()
                  setChildrenFinalTaxo()
                  navigate("/adresses")
                }}
              >
                Afficher tous les mots-clés
              </AllBtn>
            ) : mobile === true && !lantana ? (
              <button
                style={style}
                className="btn"
                onClick={() => {
                  setChoosenTaxo(null)
                  setChoosenTaxoObject()
                  setChildrenFinalTaxo()
                  navigate("/adresses")
                }}
              >
                Afficher tous les mots-clés
              </button>
            ) : null}
          </div>
          <div className={filtersTaxoItemChildrenContainer}>
            <AdressItemTaxo
              onClick={() => {
                if (childrenFinalTaxo) {
                  if (childrenFinalTaxo.includes(choosenTaxoObject.name)) {
                    const value = childrenFinalTaxo.filter(
                      (taxo) => taxo !== choosenTaxoObject.name
                    )
                    setChildrenFinalTaxo(value)
                  } else {
                    setChildrenFinalTaxo((ancientValue) => {
                      return [...ancientValue, choosenTaxoObject.name]
                    })
                  }
                } else if (finalTaxo.includes(choosenTaxoObject.name)) {
                  const value = finalTaxo.filter(
                    (taxo) => taxo !== choosenTaxoObject.name
                  )
                  setChildrenFinalTaxo(value)
                }
              }}
              onKeyDown={() => {
                if (childrenFinalTaxo) {
                  if (childrenFinalTaxo.includes(choosenTaxoObject.name)) {
                    const value = childrenFinalTaxo.filter(
                      (taxo) => taxo !== choosenTaxoObject.name
                    )
                    setChildrenFinalTaxo(value)
                  } else {
                    setChildrenFinalTaxo((ancientValue) => {
                      return [...ancientValue, choosenTaxoObject.name]
                    })
                  }
                } else if (finalTaxo.includes(choosenTaxoObject.name)) {
                  const value = finalTaxo.filter(
                    (taxo) => taxo !== choosenTaxoObject.name
                  )
                  setChildrenFinalTaxo(value)
                }
              }}
              active={
                childrenFinalTaxo
                  ? childrenFinalTaxo.includes(choosenTaxoObject.name)
                  : true
              }
              parent={false}
              className={filtersTaxoItem}
            >
              {choosenTaxoObject.name}
            </AdressItemTaxo>
            {choosenTaxoObject.children.map((element, key) => (
              <AdressItemTaxo
                onClick={() => {
                  if (childrenFinalTaxo) {
                    if (childrenFinalTaxo.includes(element.name)) {
                      const value = childrenFinalTaxo.filter(
                        (taxo) => taxo !== element.name
                      )
                      setChildrenFinalTaxo(value)
                    } else {
                      setChildrenFinalTaxo((ancientValue) => {
                        return [...ancientValue, element.name]
                      })
                    }
                  } else if (finalTaxo.includes(element.name)) {
                    const value = finalTaxo.filter(
                      (taxo) => taxo !== element.name
                    )
                    setChildrenFinalTaxo(value)
                  }
                }}
                onKeyDown={() => {
                  if (childrenFinalTaxo) {
                    if (childrenFinalTaxo.includes(element.name)) {
                      const value = childrenFinalTaxo.filter(
                        (taxo) => taxo !== element.name
                      )
                      setChildrenFinalTaxo(value)
                    } else {
                      setChildrenFinalTaxo((ancientValue) => {
                        return [...ancientValue, element.name]
                      })
                    }
                  } else if (finalTaxo.includes(element.name)) {
                    const value = finalTaxo.filter(
                      (taxo) => taxo !== element.name
                    )
                    setChildrenFinalTaxo(value)
                  }
                }}
                key={key}
                active={
                  childrenFinalTaxo
                    ? childrenFinalTaxo.includes(element.name)
                    : finalTaxo.includes(element.name)
                }
                className={filtersTaxoItem}
              >
                {element.name}
              </AdressItemTaxo>
            ))}
          </div>
          {mobile === false && lantana === true ? (
            <AllBtn
              style={style}
              className="btn"
              onClick={() => {
                setChoosenTaxo(null)
                setChoosenTaxoObject()
                setChildrenFinalTaxo()
                navigate("/adresses")
              }}
            >
              Afficher tous les mots-clés
            </AllBtn>
          ) : mobile === false && !lantana ? (
            <button
              style={style}
              className="btn"
              onClick={() => {
                setChoosenTaxo(null)
                setChoosenTaxoObject()
                setChildrenFinalTaxo()
                navigate("/adresses")
              }}
            >
              Afficher tous les mots-clés
            </button>
          ) : null}
        </div>
      ) : (
        <>
          {relatedTaxos.map((element, key) => {
            let activeBool = false
            if (finalTaxo === element.name) {
              activeBool = true
            }
            return (
              <AdressItemTaxo
                onClick={() => {
                  toggleTaxo(finalTaxo, element.name)
                }}
                onKeyDown={() => {
                  toggleTaxo(finalTaxo, element.name)
                }}
                key={key}
                active={activeBool}
                parent={element.children?.length > 0}
                className={filtersTaxoItem}
              >
                {element.name}
              </AdressItemTaxo>
            )
          })}
        </>
      )}
    </>
  )
}

FiltreTaxo.propTypes = {
  setChoosenTaxo: PropTypes.func,
  setChoosenTaxoObject: PropTypes.func,
  setChildrenFinalTaxo: PropTypes.func,
  choosenTaxo: PropTypes.string,
  choosenTaxoObject: PropTypes.object,
  childrenFinalTaxo: PropTypes.array,
  finalTaxo: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  relatedTaxos: PropTypes.array,
  toggleTaxo: PropTypes.func,
  style: PropTypes.object,
  mobile: PropTypes.bool,
  lantana: PropTypes.bool,
  isVisible: PropTypes.bool,
}
